<template>
  <div class="container-fluid">
    <vue-title
      :title="'Tospaa Code Challenge - Multiplayer Coding Game / Algorithm Challenge'"
    ></vue-title>
    <div
      id="portraitDiv"
      style="
        position: fixed;
        padding-top: 100px;
        text-align: center;
        width: 100%;
        height: 100%;
        overflow: hidden;
        left: 0;
        top: 0;
        bottom: 0;
        right: 0;
        z-index: 999999999;
        background-color: white;
        font-size: 24px;
      "
    >
      Please turn your device
      <div class="turnIcon"></div>
    </div>
    <div id="wait-container" v-show="!isStarted">
      <div id="header" class="row justify-content-center">
        <div
          class="col-8 d-flex justify-content-center"
          style="position: relative"
        >
          <img id="header-challenge-logo" src="@/assets/images/game_logo.png" />
        </div>
      </div>
      <div class="row p-3 my-auto">
        <img src="@/assets/images/waiting.gif" style="margin: 0 auto" />
      </div>
      <div class="row my-auto">
        <div
          class="col justify-content-center my-auto blinkAnimation"
          style="
            font-weight: bold;
            font-size: 32px;
            color: #69bddd;
            text-align: center;
          "
        >
          Waiting for opponent
        </div>
      </div>
      <div class="row justify-content-center my-auto">
        <a href="#" v-on:click="backToLounge">Back to Lounge</a>
      </div>
      <audio loop autoplay id="audio" v-if="!isStarted">
        <source src="@/assets/sounds/waiting.wav" type="audio/wav" />
      </audio>
    </div>

    <div id="game-container" v-show="isStarted">
      <div
        id="header"
        class="row p-1"
        style="height: auto; flex-wrap: inherit !important"
      >
        <div class="col-lg-3 my-auto">
          <img
            id="header-challenge-logo"
            src="@/assets/images/game_logo.png"
            class="img-fluid mx-auto"
          />
        </div>
        <div class="col-lg-auto d-flex justify-content-center my-auto mx-auto">
          <div
            class="d-flex flex-row bd-highlight text-center"
            style="background-color: #d0df66"
          >
            <span
              style="
                border-right: 2px solid white;
                color: white;
                font-size: 12px;
              "
              class="p-2"
              v-for="(player, i) in playerList"
              :key="i"
              >{{ player.name }}</span
            >
          </div>
        </div>
        <div class="col-lg-3 my-auto text-right">
          <a href="#" v-on:click="exitRoomClick">Logout</a>
        </div>
      </div>

      <div
        id="inner-controller-container"
        class="row my-2 p-0 justify-content-center"
      >
        <div id="boardContainer" class="col mr-2 p-0">
          <div id="board">
            <div class="d-flex flex-row align-content-center flex-wrap m-0 p-0">
              <div
                class="board-cell"
                v-for="(n, i) in 64"
                v-bind:id="'board-cell' + n"
                v-bind:key="i"
              >
                <img
                  class="img-fluid m-0 p-0"
                  v-bind:src="boardCellImage(i)"
                  :style="map[i] === 'tospaa' ? tospaaTurnStyle : ''"
                />
              </div>
            </div>
          </div>
        </div>

        <div id="code-container" class="col mr-2 p-0">
          <div class="d-flex flex-row align-content-center flex-wrap m-0 p-0">
            <div
              class="code-container-cell"
              v-for="(n, i) in 40"
              v-on:click="codeContainerClick(i)"
              v-bind:id="'code-container-cell' + n"
              v-bind:class="
                selectedCodeContainerCell === i
                  ? 'code-container-active'
                  : errorCodeContainerCell === i
                  ? 'code-container-error'
                  : 'code-container-passive'
              "
              v-bind:key="i"
            >
              <img
                v-bind:src="codeContainerCellImage(i)"
                class="img-fluid m-0 p-0"
                v-on:click="codeContainerImageClick(i)"
              />
            </div>
          </div>
        </div>

        <div id="commands-container" class="col m-0 p-0">
          <div class="d-flex flex-row align-content-center flex-wrap m-0 p-0">
            <div class="code-container-cell mb-1 mr-1">
              <img
                src="images/ileri.png"
                class="img-fluid m-0 p-0"
                v-on:click="commandClick('ileri')"
              />
            </div>
            <div class="code-container-cell mb-1 mr-1">
              <img
                src="images/sag.png"
                class="img-fluid m-0 p-0"
                v-on:click="commandClick('sag')"
              />
            </div>
            <div class="code-container-cell mb-1 mr-1">
              <img
                src="images/sol.png"
                class="img-fluid m-0 p-0"
                v-on:click="commandClick('sol')"
              />
            </div>
            <div class="code-container-cell mb-1 mr-1">
              <img
                src="images/if_esit.png"
                class="img-fluid m-0 p-0"
                v-on:click="commandClick('esit')"
              />
            </div>
            <div class="code-container-cell mb-1 mr-1">
              <img
                src="images/if_esit_degil.png"
                class="img-fluid m-0 p-0"
                v-on:click="commandClick('esit_degil')"
              />
            </div>
            <div class="code-container-cell mb-1 mr-1">
              <img
                src="images/dongu_son.png"
                class="img-fluid m-0 p-0"
                v-on:click="commandClick('dongu_son')"
              />
            </div>
            <div class="code-container-cell mb-1 mr-1">
              <img
                src="images/dongu.png"
                class="img-fluid m-0 p-0"
                v-on:click="commandClick('x')"
              />
            </div>
            <div class="code-container-cell mb-1 mr-1">
              <img
                src="images/dongux2.png"
                class="img-fluid m-0 p-0"
                v-on:click="commandClick('x2')"
              />
            </div>
            <div class="code-container-cell mb-1 mr-1">
              <img
                src="images/dongux3.png"
                class="img-fluid m-0 p-0"
                v-on:click="commandClick('x3')"
              />
            </div>
            <div class="code-container-cell mb-1 mr-1">
              <img
                src="images/dongux4.png"
                class="img-fluid m-0 p-0"
                v-on:click="commandClick('x4')"
              />
            </div>
            <div class="code-container-cell mb-1 mr-1">
              <img
                src="images/dongux5.png"
                class="img-fluid m-0 p-0"
                v-on:click="commandClick('x5')"
              />
            </div>
            <div class="code-container-cell mb-1 mr-1">
              <img
                src="images/kaya.png"
                class="img-fluid m-0 p-0"
                v-on:click="commandClick('kaya')"
              />
            </div>
            <div class="code-container-cell mb-1 mr-1">
              <img
                src="images/bos.png"
                class="img-fluid m-0 p-0"
                v-on:click="commandClick('bos')"
              />
            </div>

            <div
              id="send-button"
              class="btn btn-danger btn-lg text-center"
              v-if="!isWatching"
              v-on:click="sendCodeClick"
            >
              <p>Send code</p>
              <p v-show="gameFinishElapsedTime >= 0">
                {{ gameFinishElapsedTime }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div style="width: 100%; height: 80px"></div>
  </div>
</template>

<style lang="scss">
@import "../assets/styles/boardgame.css";
</style>

<script>
import boardGame from "@/boardgame";

export default {
  data() {
    return {
      playerList: [],
      userName: "",
      tospaaTimer: null,
      finishTimer: null,
      pingTimer: null,
      tospaaTimerInterval: 300,
      gameStartInterval: 2000,
      isStarted: false,
      isCodeSended: false,
      isSinglePlayer: false,
      isWaitingRematch: false,
      isWatching: false,
      gameFinishElapsedTime: -1,
      tospaaRotation: 0,
      tospaaInitialRotation: 0,
      tospaaIndex: -1,
      tospaaInitialIndex: 0,
      targetCounter: 0,
      selectedCodeContainerCell: 0,
      errorCodeContainerCell: -1,
      codeLastElementIndex: -1,
      selectedCodeContainerCellBeforeRun: 0,
      loopCounts: [],
      loopStartIndexes: [],
      codes: new Array(40),
      totalScore: 0,
      map: [],
      targetLocations: [],
      finalData: null,
      finalPlayerIndex: 0,
      clickSound: null,
    };
  },

  computed: {
    tospaaTurnStyle() {
      return {
        transform: "rotate(" + this.tospaaRotation + "deg)",
      };
    },

    isConnected() {
      return this.$store.state.socket.isConnected;
    },
  },

  watch: {
    isConnected() {
      if (!this.isConnected) {
        this.$router.push({
          name: "login",
        });
      }
    },
  },

  mounted: function () {
    if (!this.security()) {
      console.error("Login to lounge failed");
    } else {
      let obj = new Object();
      this.isWatching = this.$route.params.isWatching;
      this.isStarted = false;
      this.isWaitingRematch = false;
      obj.event = "changePlace";
      if (this.isWatching) {
        obj.place = "watch";
      } else {
        obj.place = "game";
      }
      this.$socket.sendObj(obj);
    }

    let pingDuration = 1000 * 90;
    this.pingTimer = setInterval(() => {
      let obj = {};
      obj.event = "ping";
      this.$socket.sendObj(obj);
    }, pingDuration);

    this.clickSound = new Audio(require("@/assets/sounds/push.wav"));
  },

  created() {
    this.$options.sockets.onmessage = (data) => this.messageReceived(data);
  },

  methods: {
    security: function () {
      this.userName = this.$route.params.userName;
      if (this.userName === "" || this.userName === undefined) {
        this.$router.push({
          name: "login",
        });
        return false;
      }
      return true;
    },

    logout: function () {
      this.$socket.close();
      this.$router.push({
        name: "login",
        params: {
          userName: "",
        },
      });
    },

    startGame: function (mapObject) {
      this.isStarted = true;
      this.isWaitingRematch = false;
      this.isCodeSended = false;
      if (!this.isWatching) {
        this.$swal
          .fire({
            title: "The game begins!",
            html: "The game will start in <b></b> milliseconds.",
            timer: this.gameStartInterval,
            timerProgressBar: true,
            allowOutsideClick: false,
            allowEscapeKey: false,
            onBeforeOpen: () => {
              this.$swal.showLoading();
            },
          })
          .then((result) => {
            console.log(result);
          });
      }
      this.initGame(mapObject);
    },

    initGame: function (mapObject) {
      this.tospaaRotation = mapObject.rotation;
      this.tospaaInitialRotation = this.tospaaRotation;
      this.map = mapObject.map;
      this.tospaaInitialIndex = this.map.indexOf("tospaa");
      this.resetCode();
      this.targetLocations = [];
      for (let i = 1; i <= 5; i++) {
        let x = this.map.indexOf("h" + i);
        if (x >= 0) {
          this.targetLocations.push(x);
        }
      }
    },

    resetCode: function () {
      this.codes = new Array(40);
      this.selectedCodeContainerCell = 0;
    },

    codeContainerCellImage: function (key) {
      return boardGame.valueToImage(this.codes[key]);
    },

    boardCellImage: function (key) {
      return boardGame.valueToImage(this.map[key]);
    },

    codeContainerClick: function (key) {
      if (this.isCodeSended) {
        return;
      }

      this.clickSound.play();

      if (key % 4 > 0) {
        let k = key % 4;
        if (
          this.codes[key - k] === undefined ||
          !this.codes[key - k].startsWith("esit")
        ) {
          return;
        }
      }
      this.selectedCodeContainerCell = key;
      this.errorCodeContainerCell = -1;
    },

    commandClick: function (command) {
      if (this.isCodeSended) {
        return;
      }

      this.clickSound.play();

      switch (command) {
        case "ileri":
        case "sag":
        case "sol":
        case "dongu_son": {
          this.codes[this.selectedCodeContainerCell] = command;
          let k = this.selectedCodeContainerCell % 4;
          this.selectedCodeContainerCell += 4 - k;
          break;
        }
        case "esit":
        case "esit_degil":
        case "kaya":
        case "bos": {
          this.codes[this.selectedCodeContainerCell] = command;
          this.selectedCodeContainerCell += 1;
          break;
        }
        case "x":
        case "x2":
        case "x3":
        case "x4":
        case "x5": {
          this.codes[this.selectedCodeContainerCell] = command;
          this.selectedCodeContainerCell += 4;
          break;
        }
      }
      this.errorCodeContainerCell = -1;
    },

    codeContainerImageClick: function (key) {
      if (!this.isCodeSended) {
        if (this.codes[key] == "esit" || this.codes[key] == "esit_degil") {
          this.codes[key + 1] = undefined;
          this.codes[key + 2] = undefined;
          this.codes[key + 3] = undefined;
        }
        this.codes[key] = undefined;

        this.clickSound.play();
      }
    },

    sendCodeClick: function () {
      this.sendCode(false);
      this.clickSound.play();
    },

    sendCode: function (forceSend) {
      if (this.isCodeSended) {
        return;
      }
      if (!forceSend) {
        let ts = boardGame.analyseCode(this.codes);
        if (ts < 0) {
          this.errorCodeContainerCell = -1 * (ts + 100);
          return;
        } else if (ts == 0) {
          this.$swal.fire(
            "You should check your code!",
            "you never used an action code",
            "warning"
          );
          return;
        }
      }
      this.isCodeSended = true;
      let obj = new Object();
      obj.event = "ccSendCode";
      obj.code = this.codes;
      this.$socket.sendObj(obj);
    },

    exitRoomClick: function () {
      this.$swal
        .fire({
          title: "Are you sure?",
          text: "",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Yes, leave!",
          cancelButtonText: "No, stay.",
        })
        .then((result) => {
          if (result.value) {
            this.backToLounge();
          }
        });
    },

    backToLounge: function () {
      this.$router.push({
        name: "lounge",
        params: {
          userName: this.userName,
        },
      });
    },

    runOnce: function () {
      let action = this.codes[this.selectedCodeContainerCell];
      switch (action) {
        case "ileri":
        case "sag":
        case "sol":
          this.doSimpleActions(action);
          this.selectedCodeContainerCell += 4;
          break;
        case "x":
        case "x2":
        case "x3":
        case "x4":
        case "x5":
          this.loopStartIndexes.push(this.selectedCodeContainerCell + 4);
          if (action.length == 1) {
            this.loopCounts.push(99);
          } else {
            let x = action.charAt(1);
            this.loopCounts.push(x);
          }
          this.selectedCodeContainerCell += 4;
          break;
        case "dongu_son":
          this.loopCounts[this.loopCounts.length - 1]--;
          if (this.loopCounts[this.loopCounts.length - 1] == 0) {
            this.loopCounts.pop();
            this.loopStartIndexes.pop();
            this.selectedCodeContainerCell += 4;
          } else {
            this.selectedCodeContainerCell =
              this.loopStartIndexes[this.loopStartIndexes.length - 1];
          }
          break;
        case "esit":
          if (
            boardGame.whatIsNext(
              this.tospaaRotation,
              this.tospaaIndex,
              this.map
            ) === this.codes[this.selectedCodeContainerCell + 1]
          ) {
            this.doSimpleActions(
              this.codes[this.selectedCodeContainerCell + 2]
            );
            this.doSimpleActions(
              this.codes[this.selectedCodeContainerCell + 3]
            );
          }
          this.selectedCodeContainerCell += 4;
          break;
        case "esit_degil":
          if (
            boardGame.whatIsNext(
              this.tospaaRotation,
              this.tospaaIndex,
              this.map
            ) !== this.codes[this.selectedCodeContainerCell + 1]
          ) {
            this.doSimpleActions(
              this.codes[this.selectedCodeContainerCell + 2]
            );
            this.doSimpleActions(
              this.codes[this.selectedCodeContainerCell + 3]
            );
          }
          this.selectedCodeContainerCell += 4;
          break;
        default:
          this.selectedCodeContainerCell += 4;
      }

      if (
        this.selectedCodeContainerCell > this.codeLastElementIndex &&
        this.targetCounter < this.targetLocations.length
      ) {
        this.totalScore = -1;
        this.successOrFailCode(
          "You failed!",
          "This code did not reach the goals of Tospaa!",
          "error"
        );
      }
    },

    doSimpleActions: function (action) {
      let targetCodes = ["h1", "h2", "h3", "h4", "h5"];
      switch (action) {
        case "ileri":
          if (
            boardGame.isGoable(this.tospaaRotation, this.tospaaIndex, this.map)
          ) {
            if (
              targetCodes.indexOf(
                boardGame.whatIsNext(
                  this.tospaaRotation,
                  this.tospaaIndex,
                  this.map
                )
              ) === this.targetCounter
            ) {
              this.targetCounter++;
            }
            switch (this.tospaaRotation) {
              case 0: //NORTH
                this.map[this.tospaaIndex] = "bos";
                this.tospaaIndex -= 8;
                this.map[this.tospaaIndex] = "tospaa";
                break;
              case 90: //EAST
                this.map[this.tospaaIndex] = "bos";
                this.tospaaIndex += 1;
                this.map[this.tospaaIndex] = "tospaa";
                break;
              case 180: //SOUTH
                this.map[this.tospaaIndex] = "bos";
                this.tospaaIndex += 8;
                this.map[this.tospaaIndex] = "tospaa";
                break;
              case 270: //WEST
                this.map[this.tospaaIndex] = "bos";
                this.tospaaIndex -= 1;
                this.map[this.tospaaIndex] = "tospaa";
                break;
            }
            if (this.targetCounter == this.targetLocations.length) {
              this.successOrFailCode(
                "You have succeeded!",
                "Score:" + this.totalScore,
                "success"
              );
            }
          }
          break;
        case "sag":
          this.tospaaRotation = (this.tospaaRotation + 90) % 360;
          break;
        case "sol":
          this.tospaaRotation = (this.tospaaRotation + 270) % 360;
          break;
      }
    },

    gameFinal: function () {
      let p = this.finalData.playerList[this.finalPlayerIndex];
      this.$swal
        .fire({
          title: "Are you ready?",
          text: p.playerName + "'s code is coming.",
          icon: "info",
        })
        .then((val) => {
          if (val) {
            this.codes = p.code;
            this.codeLastElementIndex = boardGame.getCodeLastElementIndex(
              this.codes
            );
            this.totalScore = p.score;

            this.selectedCodeContainerCell = 0;
            this.map[this.tospaaIndex] = "bos";
            this.tospaaIndex = this.tospaaInitialIndex;
            this.map[this.tospaaIndex] = "tospaa";
            this.tospaaRotation = this.tospaaInitialRotation;
            for (let i = 0; i < this.targetLocations.length; i++) {
              this.map[this.targetLocations[i]] = "h" + (i + 1);
            }
            this.targetCounter = 0;

            let tempScore = boardGame.analyseCode(this.codes);
            if (tempScore < 0) {
              this.errorCodeContainerCell = -1 * (tempScore + 100);
              this.successOrFailCode(
                "The code is incorrect.",
                "This code is incorrect and does not work",
                "error"
              );
            } else if (tempScore == 0) {
              this.successOrFailCode(
                "The code is incorrect.",
                "This code does not contain any action codes",
                "error"
              );
            } else {
              this.tospaaTimer = setInterval(() => {
                this.runOnce();
              }, this.tospaaTimerInterval);
            }
          }
        });
    },

    nextPlayerOrFinish: function () {
      if (this.finalPlayerIndex < 1 && !this.isSinglePlayer) {
        this.finalPlayerIndex++;
        this.gameFinal();
      } else {
        if (!this.isWatching) {
          let resultText = "";
          switch (this.finalData.result) {
            case "WIN":
              resultText = "You win!";
              break;
            case "TIED":
              resultText = "Draw!";
              break;
            case "LOST":
              resultText = "You lose!!";
              break;
            default:
              resultText = "";
              break;
          }
          this.$swal
            .fire({
              title: resultText,
              text: "Do you want to play again?",
              icon: "info",
              showCancelButton: true,
              confirmButtonColor: "#3085d6",
              cancelButtonColor: "#d33",
              confirmButtonText: "Yes, let's play again!",
              cancelButtonText: "No, leave the room",
            })
            .then((result) => {
              if (result.value) {
                this.isStarted = false;
                this.isWaitingRematch = true;
                let obj = new Object();
                obj.event = "rematch";
                this.$socket.sendObj(obj);
              } else {
                this.backToLounge();
              }
            });
        } else {
          this.$swal
            .fire({
              title: "The End!",
              html: "The game is over",
              allowOutsideClick: false,
              allowEscapeKey: false,
            })
            .then((result) => {
              if (result.value) {
                this.backToLounge();
              }
            });
        }
      }
    },

    successOrFailCode: function (ttl, txt, typ) {
      clearInterval(this.tospaaTimer);
      this.$swal
        .fire({
          title: ttl,
          text: txt,
          icon: typ,
          allowOutsideClick: false,
        })
        .then((val) => {
          if (val) {
            this.nextPlayerOrFinish();
          }
        });
      return;
    },

    continueOrExit: function () {
      this.$swal
        .fire({
          title: "The opponent left the room",
          text: "You can stay in the room or leave the room.",
          icon: "info",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Yes, leave!",
          cancelButtonText: "No, stay.",
        })
        .then((result) => {
          if (result.value) {
            this.$router.push({
              name: "lounge",
              params: {
                userName: this.userName,
              },
            });
          } else if (result.dismiss === this.$swal.DismissReason.cancel) {
            this.isSinglePlayer = true;
          }
        });
      return;
    },

    messageReceived: function (raw_message) {
      let receivedData = JSON.parse(raw_message["data"]);
      if (!Object.prototype.hasOwnProperty.call(receivedData, "event")) {
        console.error("event not found");
        return;
      }
      let event = receivedData["event"];
      switch (event) {
        case "roomPlayerList": {
          if (
            !Object.prototype.hasOwnProperty.call(receivedData, "playerList")
          ) {
            console.error("playerList not found");
            return;
          }

          for (let i = 0; i < receivedData.playerList.length; i++) {
            this.playerList = receivedData["playerList"];
          }
          if (this.playerList.length < 2) {
            if (this.isStarted || this.isWaitingRematch) {
              this.continueOrExit();
            } else {
              this.playerList.push("Rakip bekleniyor");
            }
          }
          break;
        }
        case "map": {
          if (!Object.prototype.hasOwnProperty.call(receivedData, "rotation")) {
            console.error("rotation not found");
            return;
          }
          this.startGame(receivedData);
          break;
        }
        case "waiting": {
          if (!Object.prototype.hasOwnProperty.call(receivedData, "duration")) {
            console.error("duration not found");
            return;
          }
          let duration = receivedData["duration"];
          let timerFinishTime = Date.now() + duration * 1000;
          this.finishTimer = setInterval(() => {
            this.gameFinishElapsedTime = Math.floor(
              (timerFinishTime - Date.now()) / 1000
            );

            if (this.gameFinishElapsedTime <= 0) {
              clearInterval(this.finishTimer);
              duration = -1;
              if (!this.isCodeSended) {
                this.sendCode(true);
              }
            }
          }, 100);
          break;
        }
        case "gameFinish": {
          if (
            !Object.prototype.hasOwnProperty.call(receivedData, "playerList")
          ) {
            console.error("players not found");
            return;
          }
          if (!Object.prototype.hasOwnProperty.call(receivedData, "result")) {
            console.error("result not found");
            return;
          }
          clearInterval(this.finishTimer);
          this.gameFinishElapsedTime = -1;
          this.finalData = receivedData;
          this.finalPlayerIndex = 0;
          this.gameFinal();
          break;
        }
      }
    },
  },
};
</script>
